import { getResizeImage } from '~/components/Image';

export const getAssetUrl = (url: string, ext?: string) => {
  if (url.includes('https')) {
    return url;
  }

  return `https://asset.kcdcdn.net/${url}.${ext ?? 'png'}`;
};

export const getCategoryImage = (url: string, ext?: string) => {
  if (url.includes('.gif')) return url;
  if (url.includes('https')) {
    return getResizeImage({
      src: url,
      width: 128,
    });
  }

  return `https://asset.kcdcdn.net/${url}.${ext ?? 'png'}`;
};
